import { render, staticRenderFns } from "./questions-button.vue?vue&type=template&id=140881ee"
import script from "./questions-button.vue?vue&type=script&lang=js"
export * from "./questions-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports